export default __webpack_public_path__ + "img/pencil.bb295af2.svg";